export default __webpack_public_path__ + "static/media/divinemercy.682c5fff.jpg";